import { ModalOpenButton } from "@msys/ui";
import { Add as AddIcon } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import React from "react";
import { CreateTodoItemModal } from "./CreateTodoItemModal.js";

interface Props extends Omit<
  React.ComponentProps<typeof CreateTodoItemModal>,
  "handleClose"
> {
  Button?: React.ReactElement;
}

export const CreateTodoItemButton = ({ Button, ...modalProps }: Props) => {
  const button = Button ?? (
    <IconButton color="primary" size="small">
      <AddIcon />
    </IconButton>
  );

  return (
    <ModalOpenButton Modal={CreateTodoItemModal} modalProps={modalProps}>
      {button}
    </ModalOpenButton>
  );
};
